import React, { Component } from 'react';
import { Layout } from 'antd';

import './footer.css';

const { Footer } = Layout;

class FooterWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {  };
    }
    render() {
        const { className, children } = this.props;

        return (
            <Footer className={ className }>
                { children }
            </Footer>
        );
    }
}

export default FooterWrapper;


// WEBPACK FOOTER //
// ./src/App/components/footer/footer.js